import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';

const paymentConfig = {
  dynamicAmount: true,
  dynamicField: 'tipoDistrato',
  options: {
    UNIPESSOAL: {
      name: 'Unipessoal',
      amount: 179.00,
      description: 'Distrato de sociedade unipessoal'
    },
    PLURIPESSOAL: {
      name: 'Pluripessoal',
      amount: 254.00,
      description: 'Distrato de sociedade pluripessoal',
      // R$ 254,00 já inclui os 2 primeiros sócios; + R$ 75,00 por sócio a partir do 3º
      quantityPricing: {
        quantityField: 'quantidadeSocios',
        unitAmount: 75.00,
        baseQuantity: 2
      }
    }
  }
};

// modeloRequerimento, tiposAssunto E tipoPedido variam juntos conforme a mesma opção
// (tipoDistrato) — por isso o "map" aqui devolve o trio completo, não só o modeloRequerimento.
const protocoloConfig = {
  field: paymentConfig.dynamicField,
  map: {
    UNIPESSOAL: { modeloRequerimento: '271', tiposAssunto: '819', tipoPedido: '467' },
    PLURIPESSOAL: { modeloRequerimento: '272', tiposAssunto: '820', tipoPedido: '468' }
  }
};

const tituloConfig = {
  tipoLancamentoId: {
    field: paymentConfig.dynamicField,
    map: { UNIPESSOAL: 141, PLURIPESSOAL: 142 }
  },
  enderecoOrigem: 'sociedadeSimples'
};

// Atualizado (2026-08): o backend passou a usar o grupo "Comercial" pros 2
// modelos (271 Unipessoal e 272 Pluripessoal) — antes o 271 usava "Residencial",
// por isso dava pra usar direto o fragmento compartilhado de sociedade.
const dadosRequerimentoConfig = DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE;

const pedidoDistratoSociedadeConfig = {
  id: 'pedido_distrato_sociedade',
  nome: 'Pedido de Distrato de Sociedade',
  descricao: 'Solicitação de registro de distrato de sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoDistrato', tipoDocumentoProcesso: 540, name: 'Contrato de Distrato', description: 'Contrato de distrato da sociedade assinado pelo(s) sócio(s) e duas testemunhas', required: true },
      { id: 'dbe', tipoDocumentoProcesso: 466, name: 'DBE - Documento Básico de Entrada', description: 'Documento Básico de Entrada, gerado no site da Redesim', required: true }
    ]
  },

  paymentConfig,
  protocoloConfig,
  tituloConfig,
  dadosRequerimentoConfig,

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection(),
        {
          title: 'Tipo de Distrato',
          fields: [
            {
              type: 'radio',
              name: 'tipoDistrato',
              label: 'Este Distrato de Sociedade é para:',
              required: true,
              options: [
                { value: 'UNIPESSOAL', label: 'Unipessoal' },
                { value: 'PLURIPESSOAL', label: 'Pluripessoal' }
              ]
            },
            {
              type: 'number',
              name: 'quantidadeSocios',
              label: 'Quantidade de Sócios',
              required: true,
              min: 2,
              step: 1,
              integer: true,
              placeholder: 'Mínimo 2',
              showWhen: { field: 'tipoDistrato', value: 'PLURIPESSOAL' }
            }
          ]
        }
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoDistratoSociedadeConfig;
